//dev avec PHP
//export const API_URL = "http://loyersws/api/";
//prod OVH
export const API_URL = "https://test.gestion.locabel.ovh/api/";

export const RENT_STATUS_PAID = "PAID";
export const RENT_STATUS_UNPAID = "UNPAID";
export const PAYPAL_CLIENT_ID = "AUe8lOTzc3MAeUUWXBPEaoODsEds0Qilu4Tw6Gz7SfXyHOqQHkOTwWa-kStik9HfzJV1RhXu2IkmVSm_";
